import { useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { ReactComponent as Logo } from "assets/img/logo.svg";
import background from "assets/img/skyscraper-background.webp";
import { Button } from "components/elements";

export const NotFound = () => {
    const navigate = useNavigate();
    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    navigate({ to: "/social" });
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate]);

    const handleGoHome = () => {
        navigate({ to: "/social" });
    };

    return (
        <div className="flex min-h-screen w-full flex-row bg-linear-to-br from-[#e8f4f8] to-[#d4e9f0] p-6">
            <div className="relative hidden w-[55%] items-end overflow-hidden rounded-2xl bg-linear-to-br from-slate-800 via-slate-700 to-slate-600 p-16 lg:flex">
                <div className="absolute inset-0 rounded-2xl">
                    <img
                        src={background}
                        alt="Modern buildings"
                        className="h-full w-full rounded-2xl object-cover opacity-60"
                    />
                </div>
                <div className="relative z-10 max-w-md text-white">
                    <h1 className="mb-4 text-4xl leading-tight font-bold">
                        Outsourced CFO &<br />
                        Accounting Solutions
                    </h1>
                    <p className="text-lg text-gray-200">For the Wealth Management Industry</p>
                </div>
            </div>

            <div className="flex w-full items-center justify-center lg:w-[40%]">
                <div className="w-full max-w-md px-8">
                    <div className="flex flex-col items-center text-center">
                        <Logo className="mx-auto mb-10 w-52" />

                        <div className="mb-6">
                            <div className="text-8xl mb-4 font-bold text-[#738a8b]">404</div>
                            <h1 className="font-roboto mb-4 text-[28px] leading-[42px] font-bold tracking-normal text-black">
                                Page Not Found
                            </h1>
                            <p className="font-roboto mb-8 text-[16px] leading-[24px] font-normal text-[#424242]">
                                Sorry, the page you're looking for doesn't exist or has been moved.
                            </p>
                        </div>

                        <div className="mb-8 rounded-lg border border-[#738a8b] bg-white/50 px-6 py-4">
                            <p className="text-sm text-[#424242]">
                                Redirecting to home in{" "}
                                <span className="font-bold text-[#738a8b]">{countdown}</span> second
                                {countdown !== 1 ? "s" : ""}...
                            </p>
                        </div>

                        <Button
                            type="button"
                            variant="primary"
                            className="h-14 w-full text-[13px] font-semibold tracking-wide"
                            onClick={handleGoHome}
                        >
                            GO TO HOMEPAGE NOW
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
